import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopService } from '../../../configuration/services/shop.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { InventoryReportService } from '../../services/inventory-report.service';
import { CategoryService } from '../../../common/services/category.service';
import { InventoryService } from '../../services/inventory.service';
import { InventoryLabeledProductService } from '../../services/inventory-labeledproduct.service';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-report-inventory',
  templateUrl: './report-inventory.component.html',
  styleUrls: ['./report-inventory.component.css'],
  providers:[ShopService,InventoryReportService,LabeledProductService,CategoryService,InventoryService, InventoryLabeledProductService]
})

export class ReportInventoryComponent implements OnInit {

  p: number = 1;
  totalItems: number = 0;
  labeledProducts: any = [];
  filters:any = {
    barcode:{contains: ""},
    name:{contains: ""},
  };
  onlyWithoutStock: boolean= false;
  onlyWithStock: boolean= false;
  onlyWithDifference: boolean= false;
  shops: any = [];
  categories: any = [];
  photos:any = [];
  filteredCategories:any = [];
  selectedCategory: string = "";
  config: any = {'sourceField': ['name']};
  selectedImage: any = null;
  showExportButton:boolean = true;
  exportParams:any ={};
  inventoryId: number = null;
  role:number = 3;


  constructor(private route: ActivatedRoute, private router: Router,private shopService:ShopService, private inventoryService: InventoryService,
    private inventoryReportService:InventoryReportService, private labeledProductService:LabeledProductService, private categoryService:CategoryService,
    private inventoryLabeledProductService:InventoryLabeledProductService ) { }

  ngOnInit() {
    this.getShops();
    this.getReport();
    this.getCategories();
    this.getInventory();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getShops(){
    return new Promise((resolve, reject) => {
        this.shopService.query({})
        .subscribe((shops) => {
            this.shops = shops;
            this.shops.unshift({id:null, name:"Ninguna"})
            resolve();
        });
    });
  }

  getShopNameFromId(id){
    let result = this.shops.filter(function (e){ return e.id === id});
    return result && result.length > 0? result[0].name:"";
  }

  getCategories(){
    return new Promise((resolve, reject) => {
        this.categoryService.query({})
        .subscribe((categories) => {
            this.categories = categories;
            resolve();
        });
    });
  }

  getCategory(value){
    if (value.id){
      this.filters.or = [
        {category:value.id},
        {family:value.id},
        {subfamily:value.id}
      ];
    }else{
      delete this.filters.or;
    }
  }

  filterCategory(value){
    this.selectedCategory = value;
    this.filteredCategories = _.filter(this.categories, function(o) { return o.name.toLowerCase().includes(value.toLowerCase()); });
    if (value == ""){
      delete this.filters.or;
    }
  }

  getReport(){
    if (this.filters.shop_id === null){
      delete this.filters.shop_id;
    }
    if (this.onlyWithoutStock){
      this.filters.expected_stock = null
    }else{
      delete this.filters.expected_stock;
    }
    if (this.onlyWithStock){
      this.filters.expected_stock = {"!": null};
    }else if (!this.onlyWithoutStock){
      delete this.filters.expected_stock;
    }
    if (this.onlyWithDifference){
      this.filters.stock_difference = {"!": 0};
    }else{
      delete this.filters.stock_difference;
    }
    var params = {
        where: _.cloneDeep(this.filters),
        sort: 'barcode DESC',
        skip: (this.p-1)*10,
        limit: 10
    };
    this.exportParams = params;
    this.inventoryReportService.query(params)
        .subscribe((labeledProducts) => {
          this.labeledProducts = labeledProducts;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.inventoryReportService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          labeledProducts.forEach((labeledProduct)=>{
            this.getProductPhotos(labeledProduct);
          });
    });
  }

  setStockToCero(){
    var r = confirm("Se pondrá el stock a 0 a todos los productos que salen en la búsqueda y no han sido contados ¿Está seguro?");
    if (r == true) {
      let body = {};
      if (this.filters.shop_id !== null){
        body["shop_id"] = this.filters.shop_id;
      }
      if (this.filters.or && this.filters.or.length > 0 && this.filters.or[0].category){
        body["category"] = this.filters.or[0].category;
      }
      if (this.filters.barcode && this.filters.barcode.contains != "" && this.filters.barcode.contains != null){
        body["barcode"] = this.filters.barcode.contains;
      }
      if (this.filters.name && this.filters.name.contains != "" && this.filters.name.contains != null){
        body["name"] = this.filters.name.contains;
      }
      this.inventoryLabeledProductService.setStockToCero(body)
          .subscribe((labeledProducts) => {
            this.getReport();
      });
    }
  }



  getProductPhotos(labeledProduct){
    this.labeledProductService.getProductPhotos(labeledProduct.id)
    .subscribe((result) => {
      if (result && result[0]){
      labeledProduct.image = result[0].image;
      }
    })
  }

  getInventory(){
    let params = {
      where: {
        end_date: null
      },
      sort: 'number DESC'
    };
    this.inventoryService.query(params)
    .subscribe((inventories) => {
      if (inventories.length > 0){
        this.inventoryId = inventories[0].id;
      }
    });
  }

  finishInventory(){
    var r = confirm("¿Está seguro de finalizar el inventario?");
    if (r == true) {
      let body = {
        id:this.inventoryId,
        end_date: new Date(),
      }
      this.inventoryService.update(body)
      .subscribe(() => {
        this.inventoryService.reset()
        .subscribe(() => {
          this.router.navigate(['/inventory']);
        });
      });
    }
  }

  selectImage(src){
    window.scroll(0,0);
    this.selectedImage = src;
  }

  unselectImage(){
    this.selectedImage = null;
  }
  roundValue(value){
    return Math.round(value * 100) / 100;
  }

  updateStock(){
    var r = confirm("¿Está seguro de actualizar el stock?");
    if (r == true) {
      this.inventoryLabeledProductService.updateStock().subscribe((inventories) => {
        this.getReport();
      });
    }
  }

  exportLabeledProductsToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Código de barras",
              field2:"Nombre",
              field3:"Tienda",
              field4:"Stock Previsto",
              field5:"Stock Post-Conteo",
              field6:"Diferencia de Stock",
              field7:"Importe Stock Previst",
              field8:"Importe Stock Post Conteo",           
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableLabeledProductsRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100
        observableLabeledProductsRequest.push(this.inventoryReportService.query(this.exportParams));
      }
      Observable.forkJoin(observableLabeledProductsRequest)
          .subscribe(data => {
            let p:any = data;
            let labeledProducts = p.flat(); 
            labeledProducts.forEach(labeledproduct =>{
              var row = {
                  field1:labeledproduct.barcode?labeledproduct.barcode:"",
                  field2:labeledproduct.name?labeledproduct.name.replace(/[^a-z0-9\s]/gi,''):"",
                  field3:labeledproduct.shop_id ?this.getShopNameFromId(labeledproduct.shop_id):"",
                  field4:labeledproduct.stock?labeledproduct.stock:"",
                  field5:labeledproduct.expected_stock?labeledproduct.expected_stock:"",
                  field6:labeledproduct.stock_difference?labeledproduct.stock_difference:"",
                  field7:labeledproduct.stock_price?this.roundValue(labeledproduct.stock_price)+"":"",
                  field8:labeledproduct.expected_stock_price?this.roundValue(labeledproduct.expected_stock_price)+"":"",
              }
              report.push(row);
            });
            var mystyle = {   
              headers:true,       
              columns:    
                  [{columnid:'field1',width:100,title: ''},   
                  {columnid:'field2',width:200,title: ''},
                  {columnid:'field3',width:100,title: 'Informe de Inventario'},
                  {columnid:'field4',width:100,title: ''},
                  {columnid:'field5',width:100,title: ''},
                  {columnid:'field6',width:100,title: ''},
                  {columnid:'field7',width:100,title: ''},
                  {columnid:'field8',width:100,title: ''}, 
                  
                  ],
              /*header*/
            
              column: {  
                  style:{
                      Alignment:{
                          Horizontal:"Center",
                          Vertical:"Center",  
                          WrapText:1
                          
                      },
                      Font:{
                          Bold:"1",
                          Color:"#000000",
                          Size:10
                      },
                      
                      Interior:{
                          Color:"#7CEECE",
                          Pattern:"Solid"
                      }
                  }},
            cells: {    
                  0:{
                      0:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid",
                                  },
                          Alignment:{
                            Horizontal:"Center",
                            Vertical:"Center",
                            WrapText: 1,
                              },  
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                          },                        
                          }  
                      },
                      1:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                  },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1, 
                      },  
                          Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                              }
                      },
                      2:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                  },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1, 
                                  }, 
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                      }                
                              }
                          },
                      3:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                  },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1,
                                  },
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                      },            
                                
                              }
                          },
                      4:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                  },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1, 
                                  },
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                      },                           
                              }
                          },
                      5:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                      },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1, 
                          },
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                      },                           
                              }
                          }, 
                      6:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                      },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1, 
                          },
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                      },                             
                          }
                          },
                      7:{style:{
                          Interior:{ 
                              Color:"#95a5a6",
                              Pattern:"Solid"
                                      },
                          Alignment:{
                              Horizontal: 'Center', 
                              Vertical: 'Center',
                              WrapText: 1,
                                  },
                          Font:{
                              Size:10,
                              Bold:"1",
                              Color:"#000000",
                      },              
                              }
                          },                          
                  }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("InformeInventario_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/inventory/components/report-inventory/report-inventory.component.ts